import React from 'react';

/**
 * Renders rows and columns for a Card template
 */
export default (props) => {
	const data = props.data;
	const widgetModel = data.widgetModel;
	const posts = data.posts;
	const PostComponent = props.PostComponent;
	const numCols = widgetModel.columns;
	let postIndex = 0;

	const getNextPost = () => {
		if (posts.length <= postIndex) {
			return '';
		}
		let post = posts[postIndex];
		postIndex++;
		return <PostComponent key={postIndex} data={data} postIndex={postIndex} isFirst={1===postIndex} isLast={postIndex === posts.length} postModel={post} widgetModel={widgetModel}></PostComponent>
	}

	const getRows = () => {
		let rows = [];
		while(postIndex < posts.length) {
			rows.push(<div key={postIndex} className={`postgrid-row row row-cols-${numCols}`}>{ getRow() }</div>);
		}
		return rows;
	}

	const getRow = () => {
		let cols =[];
		let colIndex = 0;
		let colClassName = 'postgrid-col col-md-' + parseInt(12/numCols)
		while(colIndex < numCols) {
			cols.push(<div key={colIndex} className={colClassName}>
				{getNextPost()}
			</div>)
			colIndex++;
		}
		return cols;
	}

	return getRows();
};
